'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AskUpsellSlotsTemplate } from '#pplx/frontend/apps/ask/upsell-slots/AskUpsellSlotsTemplate.js';
import { useSideCardUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/side-card/internal/useSideCardUpsellSlotPlan.js';
import { UPSELL_SLOT_ACCEPTED_LOCATIONS, UPSELL_SLOT_IDS, } from '#pplx/frontend/apps/ask/upsell-slots/UpsellSlotInventory.js';
import { UpsellButton } from '#pplx/frontend/apps/ask/upsells/handler-components/UpsellButton.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const FloatingCardUpsell = Dynamic(async () => {
    const { FloatingCardUpsell } = await import('#pplx/frontend/apps/ask/floating/FloatingCardUpsell.js');
    return { default: FloatingCardUpsell };
});
const FloatingAppDownload = Dynamic(() => import('#pplx/frontend/apps/ask/signup-ui/FloatingAppDownload.js'));
const ComputerSetupChecklistFloatingUpsell = Dynamic(async () => {
    const { ComputerSetupChecklistUpsell } = await import('#pplx/frontend/apps/ask/layout-aux/computer-setup-checklist/ComputerSetupChecklistUpsell.js');
    const ComputerSetupChecklistFloatingUpsell = (props) => _jsx(ComputerSetupChecklistUpsell, { ...props, placement: "floating" });
    return { default: ComputerSetupChecklistFloatingUpsell };
});
export const SideCardUpsellSlot = ({ callsite, sourceRequest }) => {
    const plan = useSideCardUpsellSlotPlan({
        slotId: UPSELL_SLOT_IDS.homepageSideCard,
        acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.homepageSideCard,
        source: {
            source: 'homepage',
            responseChannel: 'upsell_information',
            request: sourceRequest ?? {},
        },
        callsite,
    });
    if (!plan.show) {
        return null;
    }
    const content = plan.render.kind === 'computer_setup_checklist' ? (_jsx(ComputerSetupChecklistFloatingUpsell, { ...plan.render.props })) : plan.render.kind === 'floating_app_download' ? (_jsx(FloatingAppDownload, { ...plan.render.props })) : (_jsx(FloatingCardUpsell, { ...plan.render.props, primaryAction: _jsx(UpsellButton, { ...plan.actions.primaryCta, hideUpsell: plan.actions.hideUpsell }) }));
    return (_jsxs(_Fragment, { children: [_jsx(AskUpsellSlotsTemplate.Renderer, {}), _jsx(AskUpsellSlotsTemplate.Slot, { slot: "homeSideCard", children: content })] }));
};
//# sourceMappingURL=SideCardUpsellSlot.js.map